import { render, staticRenderFns } from "./TotalMailbox.vue?vue&type=template&id=3171267c&scoped=true"
import script from "./TotalMailbox.vue?vue&type=script&lang=js"
export * from "./TotalMailbox.vue?vue&type=script&lang=js"
import style0 from "./TotalMailbox.vue?vue&type=style&index=0&id=3171267c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3171267c",
  null
  
)

export default component.exports